// extracted by mini-css-extract-plugin
export default {"wrapper":"Wrapper_wrapper__iectm","wrapperHeader":"Wrapper_wrapperHeader__n-4Om","wrapperHeaderBetween":"Wrapper_wrapperHeaderBetween__t6qHz","title":"Wrapper_title__rMrO7"};